import { SET_DOWNLOAD_IN_PROGRESS } from '../action-types';

export const setDownloadInProgress = (downloadTypeId, id, value) => ({
  type: SET_DOWNLOAD_IN_PROGRESS,
  downloadTypeId,
  id,
  value,
});
